import { Video, MessageCircle, Laptop } from "lucide-react"
import { Badge } from "./Badge"
import { LEARNING_MODES } from "./types"

interface LearningDetailsProps {
	mode: string
}

export const LearningDetails = ({ mode }: LearningDetailsProps) => {
	if (mode === LEARNING_MODES.VIDEO_ONLINE) {
		return (
			<div className="flex flex-wrap gap-1">
				<Badge
					icon={<Laptop className="h-3 w-3" />}
					text="App mẫu"
					variant="green"
				/>
				<Badge
					icon={<MessageCircle className="h-3 w-3" />}
					text="Hỗ trợ nhóm Zalo"
					variant="blue"
				/>
			</div>
		)
	}

	if (mode === LEARNING_MODES.GOOGLE_MEET) {
		return (
			<div className="flex flex-wrap gap-1">
				<Badge
					icon={<Video className="h-3 w-3" />}
					text="Video Record"
					variant="red"
				/>
				<Badge
					icon={<Laptop className="h-3 w-3" />}
					text="App mẫu"
					variant="green"
				/>
				<Badge
					icon={<MessageCircle className="h-3 w-3" />}
					text="Giải đáp 24/7"
					variant="purple"
				/>
			</div>
		)
	}

	return null
}
